function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null);
var _ref3 = /*#__PURE__*/React.createElement("defs", null);
var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("g", {
  fill: "#85a0bb",
  id: "Core",
  transform: "translate(-260.000000, -90.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "chevron-right",
  transform: "translate(260.500000, 90.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1,0 L-0.4,1.4 L4.2,6 L-0.4,10.6 L1,12 L7,6 L1,0 Z",
  id: "Shape"
}))));
const SvgIconfinderChevronRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "12px",
    viewBox: "0 0 9 12",
    width: "9px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconfinderChevronRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconfinder_chevron-right.4d2604a4.svg";
export { ForwardRef as ReactComponent };